import React, { useState, useEffect } from 'react';
import './PointRedeem.css';
import { useNavigate } from 'react-router-dom';
import en from '../locales/eng.json';
import th from '../locales/th.json';
import CONFIG from '../config';

import getProfileImage from '../utils/getProfileImage';

function PointRedeem() {
  const navigate = useNavigate();
  const storedData = localStorage.getItem('userData');
  const [coupons, setCoupons] = useState([]);
  const [showMenu, setShowMenu] = useState(false);
const [mode, setMode] = useState('QR'); // or 'BARCODE'
const [userData, setUserData] = useState(null);
const [isLoading, setIsLoading] = useState(false);
const [userTags, setUserTags] = useState([]);
const [language, setLanguage] = useState(() => {
  return localStorage.getItem('language') || 'TH';
});
const [t, setT] = useState(language === 'EN' ? en : th);

const profileImage = getProfileImage()

useEffect(() => {
  localStorage.setItem('language', language);
  setT(language === 'EN' ? en : th);
}, [language]);

useEffect(() => {
  const fetchCoupons = async () => {
    setIsLoading(true);
    try {
      const res = await fetch(`${CONFIG.API_BASE_URL}/coupon/?is_active=true&page=1&limit=1000`);
      const result = await res.json();
      if (result.content && result.content.data) {
        setCoupons(result.content.data);
      }
    } catch (error) {
      console.error("Failed to fetch coupons:", error);
    }
    setIsLoading(false);
  };

  fetchCoupons();
}, []);




useEffect(() => {
  const fetchUserData = async () => {
    try {
      const res = await fetch(`${CONFIG.API_BASE_URL}/lineuser/fetch_user_data?line_user_id=`+ localStorage.getItem('line_user_id'));
      const result = await res.json();

      if (result?.content?.data) {
        setUserData(result.content.data);
        fetch(
          `${CONFIG.API_BASE_URL}/tags/by-line/${localStorage.getItem('line_user_id')}`,
         )
          .then((r) => r.json())
           .then((tagRes) => {
             setUserTags(tagRes.tags || []);
           })
          .catch((e) =>
             console.error("Failed to fetch user tags:", e)
         );
      } else {
        throw new Error("Invalid user data format");
      }
    } catch (e) {
      console.error("Failed to fetch user data:", e);
      navigate('/');
    }
  };

  fetchUserData();
}, [navigate]);

console.log("User Data:", userTags);

  return (
    <div style={{ backgroundColor: ' #FFFFFF'}}>


            {isLoading && (
  <div className="full-screen-spinner">
    <div className="spinner" />
  </div>
)}
      <div className="point-header-gradient">
  <img onClick={() => navigate('/')} src="/assets/logo-ujoy.png" alt="logo" className="logo-ujoy" />
  <div className="right-section">
  <div className="lang-selector">
  <button
    className={`lang-button ${language === 'TH' ? 'active' : ''}`}
    onClick={() => setLanguage('TH')}
  >
    TH
  </button>
  |
  <button
    className={`lang-button ${language === 'EN' ? 'active' : ''}`}
    onClick={() => setLanguage('EN')}
  >
    EN
  </button>
</div>


    {/* <img src="/assets/avartar.png" alt="avatar" className="profile-avatar" /> */}
            {showMenu ? 
          <div >
           
 {showMenu && (
  <>
   <img
  onClick={() => navigate('/profile')}
  src="/assets/mascot-full.png"
  alt="avatar"
  style={{ position: 'relative', zIndex: 9998 }} // ADD position
/>
    <div className="menu-overlay" onClick={() => setShowMenu(false)}></div>
    <div className="menu-popup-wrapper">
      <div className="menu-popup">
        <div className="menu-item" onClick={() => { navigate('/my-coupon'); setShowMenu(false); }}>
          <img src="/assets/icon-coupon.png" alt="coupon" />
          <span>คูปองของฉัน</span>
        </div>
        <div className="menu-item" onClick={() => { navigate('/point-redeem'); setShowMenu(false); }}>
          <img src="/assets/icon-redeem.png" alt="redeem" />
          <span>แลกคะแนน</span>
        </div>
        <hr className="dashed-line" />
        <div className="menu-item" onClick={() => { navigate('/point-history'); setShowMenu(false); }}>
          <img src="/assets/icon-points.png" alt="points" />
          <span>คะแนนสะสม</span>
        </div>
        <hr className="dashed-line" />
      </div>
    </div>
  </>
)}


  </div>
  : <div><img
  onClick={() => navigate('/profile')}
  src={
    userData?.line_image_url
      ? userData.line_image_url
      : "/assets/avartar.png"
  }
  alt="avatar"
  className="profile-avatar"
/></div>}

  </div>
    </div>

    <div className="point-header-bar">
    <button className="back-button" onClick={() => navigate(-1)}>
  <img src="/assets/arrow_back.png" alt="Back" className="back-icon" />
</button>
  <span className="point-header-title">{t.pointredeem.pointredeem}</span>
</div>


{/* Points summary and coupon button */}
<div className="points-summary-section">
  <div className="points-balance">
    <span className="points-amount">{userData?.point?.toLocaleString() || 0}</span>
    <img src="/assets/coin.png" alt="coin" className="coin-icon" />
  </div>

  <p className="points-expiry-text">{userData?.point?.toLocaleString() || 0} {t.pointredeem.point}</p>
  <button className="my-coupon-button" onClick={() => navigate('/my-coupon')}>
    <img src="/assets/confirmation_number.png" alt="icon" />
    {t.pointredeem.my_coupon}
  </button>
</div>

<hr className="dashed-line-gray" />
<br/>
{/* Coupon list */}
<div className="coupon-list">
  {coupons
    .filter(coupon => {
      // show if no tags
      if (!Array.isArray(coupon.tags) || coupon.tags.length === 0) {
        return true;
      }
      // otherwise only show if there's at least one matching tag
      return coupon.tags.some(tagId =>
        userTags.includes(String(tagId))
      );
    })
    .map((coupon, index) => (
      <div key={index} className="coupon-card-potin-redeem">
        <img
          src={coupon.image_url}
          alt={language === 'EN' ? coupon.name_en : coupon.name}
          className="coupon-image-potinredeem"
        />

        <div className="coupon-details-potinredeem">
          <p className="coupon-title-potinredeem">
            {language === 'EN' ? coupon.name_en : coupon.name}
          </p>
          <p className="coupon-subtitle-potinredeem">
            {language === 'EN'
              ? coupon.short_description_en
              : coupon.short_description}
          </p>
          <p className="coupon-points-potinredeem">
            {coupon.point_cost?.toLocaleString() || 0}
            <img
              src="/assets/coin.png"
              alt="coin"
              className="coin-icon-card"
            />
          </p>
          <button
            className="redeem-button-potinredeem"
            onClick={() =>
              navigate(`/coupon-description?coupon_id=${coupon.id}`)
            }
          >
            {t.pointredeem.redeem_coupon}
          </button>
        </div>
      </div>
    ))}
</div>






    </div>
  );
}

export default PointRedeem;
